import React from 'react'
import PropTypes from 'prop-types'
import Button from 'js/components/Button/Button'
import { Link } from 'react-router-dom'
import AppButtons from 'js/components/AppButtons/AppButtons'
import { FormattedMessage } from 'react-intl'
import messages from './messages'

function MealPlansPageHero({
  nativeAd,
  backgroundStyles,
  heading,
  buttonText = <FormattedMessage {...messages.start_meal_plan} />,
  buttonLink = '/signup',
  mealPlanName,
  readMoreLink,
  ...props
}) {
  return (
    <div style={backgroundStyles} className="relative overflow-hidden">
      <section className="relative z-10 mx-auto flex w-full max-w-968 flex-col px-32 py-80 text-center md:w-2/3 lg:w-1/2 xl:py-128">
        <h1 className="type-large mb-32 text-white">{heading}</h1>
        {nativeAd ? (
          <AppButtons center={true} />
        ) : (
          <div className="mx-auto w-full">
            <Button color="white" big use={Link} to={buttonLink}>
              {buttonText}
            </Button>
            {readMoreLink && (
              <a
                href={readMoreLink}
                className="my-24 inline-block border-b-1 border-white-transparent text-white hover:border-white"
              >
                <FormattedMessage
                  id="MealPlansPage_ReadMore"
                  defaultMessage="Read more about {MEALPLAN_NAME}"
                  values={{ MEALPLAN_NAME: mealPlanName }}
                ></FormattedMessage>
              </a>
            )}
          </div>
        )}
      </section>
      {props.children}
    </div>
  )
}

MealPlansPageHero.propTypes = {
  nativeAd: PropTypes.bool.isRequired,
  heading: PropTypes.any.isRequired,
  backgroundStyles: PropTypes.object,
  buttonText: PropTypes.string,
  buttonLink: PropTypes.string,
  children: PropTypes.any,
  mealPlanName: PropTypes.string,
  readMoreLink: PropTypes.string,
}

export default MealPlansPageHero
